import { render, staticRenderFns } from "./HomeEstudiante.vue?vue&type=template&id=540674fa&scoped=true"
import script from "./HomeEstudiante.vue?vue&type=script&lang=js"
export * from "./HomeEstudiante.vue?vue&type=script&lang=js"
import style0 from "./HomeEstudiante.vue?vue&type=style&index=0&id=540674fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540674fa",
  null
  
)

export default component.exports